<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <!-- Confirmation dialog for deleting aggregator start-->
            <v-dialog v-model="showDeleteModal" persistent max-width="320">
                <v-card>
                    <v-toolbar color="orange" dark small>
                        <v-toolbar-title>Delete Aggregator Type</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn dark icon @click="showDeleteModal=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        Are you sure you want to delete this aggregator?
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="dark" small @click="showDeleteModal=false">
                            No
                        </v-btn>
                        <v-btn color="orange " class="white-text" small @click="deleteAggregator">
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- aggregator detail modal start -->
            <v-dialog v-model="showAggregatorDetail" max-width="60%" scrollable>
                <v-card>
                    <v-toolbar dark color="orange">
                        <v-toolbar-title>Aggregator Details</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="showAggregatorDetail=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="aggregatorDetails && Object.keys(aggregatorDetails).length">
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Name</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">{{aggregatorDetails.name}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Description</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1 textwrap">{{aggregatorDetails.description}}</div>
                                </div>
                            </div>
                            <div class="pa-2 grey lighten-3 d-flex align-top mb-1">
                                <div class="flex xs5 text-xs-left">
                                    <div class="header text--darken-1">Equipment Name</div>
                                </div>
                                <div class="flex xs1 text-xs-left">
                                    <div class="header text--darken-1">:</div>
                                </div>
                                <div class="flex xs6 text-xs-right">
                                    <div class="header text--darken-1">
                                        <v-chip v-for="(val, index) in aggregatorDetails.AggregatorCode" v-bind:key="index">
                                            {{val.mapped_name}}
                                        </v-chip>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- role detail modal end -->
            <!-- Confirmation dialog for deleting role end-->
            <v-flex lg12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Aggregators</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn" v-if="permissionName=='all'" :to="{name:'AddAggregator'}">
                            <v-icon color="black">add</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-card-text>  <v-text-field  solo append-outer-icon="search"  class="customTxt"   placeholder="Type something to search..." v-model="search" hide-details></v-text-field>
                      </v-card-text>
                        <v-data-table :disable-initial-sort="true" :headers="headers" :search="search" :items="aggregators" :rows-per-page-items="[10,25,50,{text:'All','value':-1}]" class="elevation-1" item-key="code">
                            <template slot="items" slot-scope="props">
                                <td>{{props.item.name}}</td>
                                <td>
                                    <v-chip v-for="(val, index) in props.item.AggregatorCode" v-bind:key="index">
                                        {{val.mapped_name}}
                                    </v-chip>
                                </td>
                                <td width="150px" class="text-xs-center">
                                    <v-btn class="remove-border" depressed outline icon fab dark color="orange" small @click="showAggregatorDetail=true; aggregatorDetails=props.item;">
                                        <v-icon>fa-eye</v-icon>
                                    </v-btn>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
export default {
    mounted() {
        this.get();
        this.permissionName = this.$store.state.user ? this.$store.state.user.permissions.equipments : null;
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        get() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            services
                .get("aggregators/list", {
                    Authorization: "Bearer " + this.$store.state.user.token
                })
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    if (res.status === 200) {
                        self.aggregators = res.data.data;
                    }                    
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, 'red');
                });
        },
        deleteAggregator() {
            const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            self.showDeleteModal = false;
            services
                .delete("aggregators/delete", {
                    id: self.deleteAggregatorId
                }, {
                    Authorization: "Bearer " + this.$store.state.user.token
                })
                .then(res => {
                    if (res.status === 200) {
                        self._showToast(res.data.message);

                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, 'red');
                });
        }
    },
    data() {
        return {
            search: "",
            deleteAggregatorId: null,
            showDeleteModal: false,
            showAggregatorDetail: false,
            aggregatorDetails: {},
            permissionName: null,
            headers: [
                {
                    text: "Aggregator Name",
                    value: "name"
                },
                {
                    text: "Equipment Name",
                    value: "name"
                },
                {
                    text: "Actions",
                    value: "",
                    sortable: false,
                    align: 'center'
                }
            ],
            aggregators: [],
            breadcrumbs: [{
                    name: 'Dashboard',
                    to: "/dashboard",
                    disabled: false
                },
                {
                    name: 'Reporting',
                    to: "/comingsoon",
                    disabled: false
                },
                {
                    name: 'Aggregators',
                    disabled: true
                }
            ]
        };
    }
};
</script>

<style>
.no-underline {
    text-decoration: none;
}
.v-btn.remove-border {
    border:none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/aggregators/List.vue